export const currencyFieldBasicData = [
  "title",
  "name",
  "placeholder",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const checkboxFieldBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const datePickerBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const datetimePickerBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const dropDownBasicData = [
  "title",
  "name",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const fileUploadFieldBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const linearScaleBasicData = [
  "title",
  "name",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const multichoiceBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const ratingFieldBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const multiLineBasicData = [
  "title",
  "name",
  "placeholder",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const singleLineBasicData = [
  "title",
  "name",
  "placeholder",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const formLinkFieldBasicData = ["title", "name", "description" , "fieldSize", ];
export const yearSelectorBasicData = [
  "title",
  "name",
  "description",
  "placeholder",
  "fieldSize",
];
export const sequenceBasicData = ["title", "description", "fieldSize"];
export const timePickerBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const numberInputBasicData = [
  "title",
  "name",
  "placeholder",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const pincodeBasicData = [
  "title",
  "name",
  "placeholder",
  "initialValue",
  "description",
  "descriptionType",
  "fieldSize",
];
export const lookupFieldBasicData = [
  "title",
  "name",
  "description",
  "initialValue",
  "fieldSize",
];

export const tableFieldBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];

export const timeSlotBasicData = ["title", "name", "description", "fieldSize"];

export const buttonBasicData =[
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const bannerBasicdata = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];

export const geoLocationFieldBasicData = [
  "title",
  "name",
  "fieldSize",
];

export const signatureFieldBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];

export const doublePanelBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const captchaBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];

export const linkedDropdownBasicData = [
  "title",
  "name",
  "description",
  "descriptionType",
  "fieldSize",
];
export const descriptionRichText = [
  "title",
  "name",
  "fieldSize",
];